import { ResolutionDetailsContext } from '@bo-hooks/resolutions/resolutionDetails';
import { ResolutionsHeader } from '@bo-components/resolutions/resolutionsList';
import { useContext } from 'react';

/* In the future when we need add more functionality to the details header,
   remove the ResolutionsHeader and build from scratch instead of adding more conditional logic to ResolutionsHeader   */

export const ResolutionDetailsHeader = () => {
  const {
    isNewResolution,
    resolutionDetails: { resolutionId }
  } = useContext(ResolutionDetailsContext);

  return (
    <ResolutionsHeader
      isHomePage={false}
      title={isNewResolution ? 'New Resolution' : `Resolution# ${resolutionId}`}
    />
  );
};
